export default "__VITE_ASSET__DjfwLDQU__"